export default __webpack_public_path__ + "static/media/institution.34d684fe.svg";